import type { SellerServicesRepository } from "../../../repositories/sellerServicesRepository"
import { UseCase } from "../../useCase"
import { DeleteServiceRollbackResponse } from "./response"
import { DeleteServiceRollbackRequest } from "./request"

export class DeleteServiceRollbackUseCase
	implements UseCase<DeleteServiceRollbackRequest, DeleteServiceRollbackResponse>
{
	private _repository
	constructor({ SellerServicesRepository }: { SellerServicesRepository: SellerServicesRepository }) {
		this._repository = SellerServicesRepository
	}

	exec({ serviceId }: DeleteServiceRollbackRequest): Promise<DeleteServiceRollbackResponse> {
		return this._repository.deleteServiceRollback(serviceId)
	}
}
